import React from "react";
import { StoryBoard } from "@/components/storyBoard";

export default function StoryBoardPage() {
  return <StoryBoard />;
}
